export default {
  aboutYunDing: '关于云盯',
  backstageLogin: '后台登录',
  softwareDownloads: 'software download',
  slogan: 'Yundvision Smart Store management expert',
  pcPlugin: 'PC plug-in',
  pcClient: 'PC',
  enterpriseNum: 'Enterprise code',
  loginNum: 'Login account',
  welcome: '欢迎登录云盯管理系统',
  nextAutoLogin: 'Auto login next time',
  loginImmediately: 'Log In',
  accountLogin: 'Back to account login',
  backToLogin: 'Return to login',
  yundingOnline: '云盯360',
  $downloadApp: '下载APP',
  $zhangkongStore: '掌控天下门店',
  $copyright: '版权所有©成都汇纳智能科技有限公司',
  loginDownLoadTips1: 'Please download the plugin to use the latest gimbal function',
  nextAutomaticLogin: 'Auto login next time',
  logIn: 'Log In',
  softwareDownload: 'software download',
  loginPleaseEnter: 'Please enter ',
  password: 'password',
  switchLanguage: 'Switch language',
  oldPsd: 'Old password',
  newPsd: 'New password',
  repeatNewPsd: 'Repeat new password',
  inputOldPsd: 'Please input the old password',
  inputNewPsd: 'Please input a new password',
  inputNewPsdAgain: 'Please input the new password again',
  psdNotLegal: 'Wrong password (should be 6-16 bytes, the bytes can be uppercase and lowercase letters, numbers, and ~!@#$%^*()_+)',
  newPsdNotLegal: 'The password is illegal（the symbol can be only chosen from these charactors: ?!@#$%^*();\'~.,）',
  psdsNotMatch: 'The password entered twice is inconsistent',
  psdNotLegal2: 'The password is illegal',
  updatePsd: 'Change password',
  Confirm: 'Confirm',
  spacesCannotBeIncluded: 'Spaces and Chinese symbols cannot be included, special symbols only allow ?!@#$%^*();\'~.',
  theLengthIsSixToSixteenCharacters: 'The length is 6-16 characters',
  theLengthIsEightToSixteenCharacters: 'The length is 8-16 characters',
  passwordSecurityLevelMedium: 'Must contain at least 2 types of uppercase and lowercase letters, numbers, and special symbols.',
  passwordSecurityLevelHigh: 'Must contain at least 3 types of uppercase and lowercase letters, numbers, and special symbols.',
  passwordSecurityLevelLow: 'You can use numbers, uppercase and lowercase letters, special symbols.',
  retrieveLoginPassword: 'Retrieve login password',
  retrievePassword: 'Retrieve password',
  Previous: 'Previous',
  pleaseInputYourAccount: 'Please input your account',
  pleaseInputThePhoneNumber: 'Please input the phone number',
  pleaseInputTheEnterpriseNumber: 'Please input the enterprise number',
  pleaseInputAnewPassword: 'Please input a new password',
  phoneNumber: 'Phone number',
  Next: 'Next',
  newPassword: 'New password',
  inputAccount: 'Login account',
  Description: 'If you need to modify the mobile phone number which receive the verification code, please contact the administrator and go to the platform to modify in [Configuration Management]-[Employee Configuration]',
  getVerificationCode: 'Get verification code',
  enterpriseCode: 'Enterprise code',
  Complete: 'Complete',
  Account: 'Account',
  forgotPassword: 'Forgot password',
  SMSVerificationCode: 'SMS verification code',
  pleaseInputTheSMSVerificationCode: 'Please input the SMS verification code',
  repeatNewPassword: 'Repeat new password',
  PleaseRepeatNewPassword: 'Please repeat new password',
  pleaseInputACorrectPhoneNumber: 'please input a correct phone number',
  Reacquire: 'Reacquire ({number}s)',
  Verification: 'Verification',
  resetPassword: 'Reset password',
  pleaseChangeYourPassword: 'When logging in for the first time, To ensure the security of your account, please change the password ',
  thePasswordOfYourAccountHasBeenReset: 'The password of your account has been reset. To ensure the security of your account, please change the password',
  thePasswordOfYourAccountHasExpired: 'The password of your account has expired, please change the password',
  theSecurityOfYourAccountPasswordIsTooLow: 'In order to ensure the security of enterprise account, the system is upgraded for security level of the password, please modify the password',
  thePasswordContainsIllegalCharacters: 'The password contains illegal characters, please follow the prompts to change the password',
  passwordChanged: 'Password changed',
  Back: 'Back',
  Welcome: 'Welcome',
  enterTheOfficialWebsite: 'Enter the official website',
  viewDetails: 'View details',
  broswers: '360 Browser',
  otherLoginMethods: 'Other login methods',
  qiyeweixin: 'WeCom',
  qiyeweixinLogin: 'WeCom login',
  qiyeweixinInfo: 'Please enter the enterprise number to generate a QR code',
  qiyeweixinInput: 'Please contact the system administrator to obtain the enterprise number',
  getQRCode: 'Generate QR code',
  otherQiye: 'Choose another enterprise to log in to',
  personInfo: 'Supplementary information',
  email: 'Email',
  placeInputEmail: 'Place Input Email',
  placeInputACorrectEmail: 'Place Input A Correct Email',
  placeInputPassword: 'Place Input Password',
  confirmPwd: 'Confirm',
  personInfoMsg: 'When enterprise WeChat users scan and log in for the first time, they need to obtain the users personal information as the basic information of the account for subsequent platform login and use; After completing the information, when using the enterprise WeChat scanning code in the future, it will automatically log in to the system without password',
  scanDownload: 'Scan the code to download',
  feishu: 'Lark',
  feishuLogin: 'Lark Login',
  enterpriseBind: 'Enterprise binding',
  feishuBindMsg: 'For the first time using Cloud Staring 360, enterprise binding is required. After successful binding, the Feishu address book will be synchronized as the login account for the Cloud Staring 360 system. After successful binding, you can continue to use Cloud Staring 360. Logging in to the Cloud Staring system through Feishu will be a new account, and the operation permissions and regional store permissions of the account need to be granted separately in the Cloud Staring system',
  inputBindEnterpriseCode: 'Please enter the enterprise number that needs to be bound',
  inputEnterpriseCode: 'Please enter the enterprise code',
  inputSuperAdminAccountAndPsd: 'Please enter the super management account and password',
  inputSuperAdminAccount: 'Please enter the super management account',
  inputSuperAdminPassword: 'Please enter the super management password',
  bindQuestion1: `Don't know how to bind the enterprise account?`,
  bindQuestion2: 'Please contact Cloud Staring after-sales technical personnel',
  bindQuestion3: 'Or make a phone call to',
  useAccount: 'Log in with account password',
  placeInputEnterpriseCode: 'Place Input Enterprise Code',
  accountInfo: 'Account message',
  loginAuthInfo: 'The current role or account does not have login authority. Please contact the administrator to confirm and activate permission information',
  authModalTitle: 'Message Info',
  authChangeInfo: 'The permissions have been changed, please log in again',
  psdLength: 'The length is {min}-{max} characters',
  passwordStrengthWeak: 'Weak',
  passwordStrengthMedium: 'Medium',
  passwordStrengthStrong: 'Strong',
  loginFailed: 'Login failed',
  dingtalk: 'DingTalk',
  weixin: 'WeChat',
  app: 'App',
  welcomeLogin: 'Welcome',
  selectLoginMethod: 'Please select a login method to access Yunding SaaS Platform',
  scanCodeLogin: 'QR Code Login',
  accountLoginTab: 'Account Login',
  thirdPartyLoginTab: 'Third-party Login',
  enterpriseCodeLogin: 'Enterprise Code Login',
  verifyCodeLogin: 'Verification Code Login',
  accountLabel: 'Account',
  pleaseEnterAccount: 'Please enter account',
  pleaseEnterPassword: 'Please enter password',
  rememberAccount: 'Remember account',
  pleaseEnterPhoneNumber: 'Please enter phone number',
  pleaseEnterCorrectPhoneNumber: 'Please enter a valid phone number',
  verifyCodeLabel: 'Verification Code',
  pleaseEnterVerifyCode: 'Please enter verification code',
  pleaseEnterNumDigitCode: 'Please enter {num}-digit numeric verification code',
  pleaseEnterCorrectVerifyCodeFormat: 'Please enter a valid verification code format',
  loginBtn: 'Login',
  pleaseEnterEnterpriseCode: 'Please enter enterprise code',
  iHaveReadAndAgree: 'I have read and agree to',
  userServiceAgreement: 'User Service Agreement',
  andText: 'and',
  privacyPolicyText: 'Privacy Policy',
  serviceAgreementTitle: 'User Service Agreement',
  privacyPolicyTitle: 'Privacy Policy',
  serviceAgreementAndPrivacy: 'Service Agreement and Privacy Protection',
  disagree: 'Disagree',
  agree: 'Agree',
  pleaseReadAgreement: 'Please read and agree to the',
  continueUse: 'before continuing.',
  bindAccount: 'Bind Account',
  pleaseBindEnterpriseAccount: 'Please bind your enterprise account',
  confirmBind: 'Confirm Binding',
  inputAccountStep: 'Enter Account',
  identityVerificationStep: 'Identity Verification',
  resetPasswordStep: 'Reset Password',
  accountInfoVerify: 'Account Information Verification',
  pleaseEnterEnterpriseCodeAndAccount: 'Please enter your enterprise code and personal account',
  securityVerification: 'Security Verification',
  pleaseCompleteIdentityVerification: 'Please complete identity verification to reset password',
  setNewPassword: 'Set New Password',
  pleaseEnterYourNewPassword: 'Please enter your new password',
  personalAccount: 'Personal Account',
  pleaseEnterPersonalAccount: 'Please enter personal account',
  systemWillAutoFillPhone: 'The system will automatically retrieve the bound phone number for identity verification',
  systemAutoFilledContact: 'The system has automatically retrieved your contact information',
  verifyCodeWillBeSentToPhone: 'Verification code will be sent to the above phone number',
  noPhoneBoundWarning: 'If your account is not bound with a phone number, you cannot proceed to the next step',
  needModifyPhoneContactAdmin: 'Please contact the administrator to modify your phone number',
  confirmNewPassword: 'Confirm New Password',
  pleaseEnterNewPasswordAgain: 'Please enter the new password again',
  backToLoginPage: 'Back to Login',
  backToPreviousStep: 'Back to Previous Step',
  pleaseEnterFourDigitCode: 'Please enter 4-digit verification code',
  newPasswordNotMeetRules: 'New password does not meet security rules',
  passwordsNotMatch: 'Passwords do not match',
  passwordResetSuccess: 'Password reset successfully',
  scanSuccess: 'Scan Successful',
  qrcodeRefreshText: 'Refresh QR Code',
  qrcodeValidity: 'QR Code Validity: ',
  scanCodeLoginSteps: 'QR Code Login Steps',
  step1OpenApp: 'Open Yunding APP homepage',
  step2ScanQRCode: 'Tap upper-right "Scan" to scan the QR code',
  step3ConfirmLogin: 'Confirm login on APP for automatic web login',
  selectAccount: 'Select Account',
  multipleAccountsDetected: 'Multiple accounts detected, please select one to login',
  enterpriseCodeLabel: 'Enterprise Code: ',
  loginAccountLabel: 'Login Account: ',
  confirmLogin: 'Confirm Login',
  selectThirdPartyLogin: 'Select Third-party Platform Login',
  clickIconToAuthorize: 'Click the icon below to be redirected to the corresponding platform for authorization',
  pleaseEnterEnterpriseCodeToGetApp: 'Please enter enterprise code to get {name} app',
  getApp: 'Get App',
  enterpriseNotBind: 'Enterprise not bound',
  enterpriseCancelledBind: 'Enterprise binding cancelled',
  userNotExist: 'User does not exist',
  systemError: 'System error',
  pleaseEnterVerificationCode: 'Please enter {maxLength}-digit verification code',
  retryAfterSeconds: 'Retry in {remaining}s',
  userNotBind: 'User not bound to enterprise account',
  dingtalkUserNotExist: 'DingTalk user does not exist',
  platformDisabled: 'Platform disabled, please contact the administrator',
}
